













import {Component, Vue} from "vue-property-decorator";
import AppDialogContainer from "@/components/AppDialogContainer.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import StickyPanel from "@/components/StickyPanel.vue";
import {bus} from "@/plugins/bus";
import {EventEmitter} from "@/interfaces/store-interfaces/event-emitter.interface";

@Component({
  components: {
    AppDialogContainer,
    StickyPanel,
    Header,
    Footer,
  }
})
export default class ContentPage extends Vue {
  isInit = false;
  iosFullscreen = false;

  get isMenuOpen() {
    return this.$store.state.dialog.menu;
  }

  created() {
    bus.$on(EventEmitter.Events.IOS_FULLSCREEN_CHANGE, this.iosFullscreenChange);
  }

  mounted() {
    this.isInit = true;
  }

  iosFullscreenChange(state) {
    this.iosFullscreen = state;
  }

  destroyed() {
    bus.$off(EventEmitter.Events.IOS_FULLSCREEN_CHANGE, this.iosFullscreenChange);
  }
}
